var render = function render(){var _vm=this,_c=_vm._self._c;return _c('body',[_c('div',{staticClass:"ui-detail-swiper",class:{
      'hide-promotion-bottom': _vm.ispromotion,
      'has-goods-stock': _vm.isStock <= 0,
    }},[_c('product-info',{on:{"mbBodytop":_vm.getmbBodytop,"reviewtop":_vm.getreviewtop}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }